import {
  API_ENDPOINTS,
  apiRequest,
  ReturnTypeWithPagination,
  timeAsSeconds,
  VehicleGetDTO,
} from "@alba-cars/common-modules";
import qs from "qs";

import { AgentVehicle } from "@/lib/types/vehicle-agent";

type VehicleRequestAccess = {
  accessToken?: string | null;
  includeDistance?: boolean;
};

// FNV-1a: cache tags only need a stable key, and Node's crypto would ship a ~100 KiB polyfill to the browser.
export function hashString(text: string) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16);
}

export async function fetchCars(
  queryOptions: Omit<VehicleGetDTO, "toPlain" | "validate">,
  locale?: string,
  requestAccess?: VehicleRequestAccess,
) {
  const query: Omit<VehicleGetDTO, "toPlain" | "validate"> = {
    ...queryOptions,
    filter: {
      ...queryOptions.filter,
      includeReserved: true,
      status: ["Reserved", "Published"],
    },
  };

  const queryString = qs.stringify(query, {
    skipNulls: true,
    allowEmptyArrays: false,
    allowDots: false,
    arrayFormat: "brackets",
  });

  const mediaSelectQuery = qs.stringify(
    {
      options: {
        select: ["media.id", "media.refId", "media.mediaUrl", "media.mediaType", "media.mediaIndex"],
      },
    },
    {
      skipNulls: true,
      allowEmptyArrays: false,
      allowDots: false,
      arrayFormat: "repeat",
    },
  );

  const distanceQuery = requestAccess?.includeDistance ? "&includeDistance=true" : "";
  const endpoint = `${API_ENDPOINTS.vehicle.getAll.toString()}?${queryString}&${mediaSelectQuery}${distanceQuery}`;

  const response = await apiRequest<
    ReturnTypeWithPagination<(AgentVehicle & { isSignature?: boolean; isOnSale?: boolean })[]>
  >(endpoint, {
    headers: {
      "Accept-Language": locale || "en",
      ...(requestAccess?.includeDistance && requestAccess.accessToken
        ? { Authorization: `Bearer ${requestAccess.accessToken}` }
        : {}),
    },
    ...(requestAccess?.includeDistance
      ? { cache: "no-store" as const }
      : {
          next: {
            tags: ["vehicles", hashString(queryString), locale || "en"],
            revalidate: timeAsSeconds({ minutes: 0 }),
          },
        }),
  });

  return response;
}
